export const S2_DASHBOARD_TABS = [
  { id: "fund_overview", label: "Fund Overview", path: "fund_overview" },
  { id: "capital_account", label: "Capital Account", path: "capital_account" },
  { id: "portfolio", label: "Portfolio", path: "portfolio" },
  { id: "analytics", label: "Analytics", path: "analytics" },
  { id: "audit", label: "Audit", path: "audit" },
] as const;

export type S2DashboardTabId = (typeof S2_DASHBOARD_TABS)[number]["id"];

export const S2_DASHBOARD_ROUTES = {
  dataUpload: "data_upload",
  fundOverview: "fund_overview",
  capitalAccount: "capital_account",
  portfolio: "portfolio",
  analytics: "analytics",
  audit: "audit",
} as const;

export const S2_DASHBOARD_ALIAS_ROUTES = {
  dataUpload: "s2_data_upload",
  fundOverview: "s2_fund_overview",
  capitalAccount: "s2_capital_account",
  portfolio: "s2_portfolio",
  analytics: "s2_analytics",
  audit: "s2_audit",
} as const;

// Shared style for grouped headers in S2 tables (FO / Portfolio / CA).
export const S2_GROUP_HEADER_CLASS =
  "bg-[#001d6c] px-3 py-2 text-center text-[11px] font-bold uppercase tracking-wider text-white h-auto";
